'use client';

import { cn } from '@ahm/common-helpers';
import type { PropsWithChildren } from 'react';

interface DesktopLayoutProps extends PropsWithChildren {
  sidebar?: React.ReactNode;
  className?: string;
}

/**
 * Desktop Layout
 * - With `sidebar`: 2-column grid (main + sticky right rail).
 * - Without `sidebar`: single full-width canvas that fills the viewport.
 *   Content inside distributes itself via its own responsive grids.
 */
export default function DesktopLayout({
  children,
  sidebar,
  className,
}: DesktopLayoutProps) {
  return (
    <div className={cn('w-full', className)}>
      {/* Mobile: Single column */}
      <div className="md:hidden">{children}</div>

      {/* Desktop */}
      {sidebar ? (
        <div className="hidden md:grid md:grid-cols-[1fr_380px] xl:grid-cols-[1fr_420px] gap-8 max-w-screen-2xl mx-auto p-6 md:px-12">
          <main className="min-w-0 w-full">{children}</main>
          <aside className="sticky top-24 h-[calc(100vh-120px)] overflow-hidden">
            {sidebar}
          </aside>
        </div>
      ) : (
        <main className="hidden md:block w-full max-w-[1400px] mx-auto px-6 lg:px-10 xl:px-12">
          {children}
        </main>
      )}
    </div>
  );
}
